export const StatusArrayObject = [
  'COMPLETED',
  'CANCELED',
  'WAIT_ADJUST',
  'PENDING',
  'ADJUSTED',
];

export const PaymentMethods: { [key: string]: string } = {
  payment_link: 'Link',
  store_credit: 'Saldo',
  physical_card: 'POS',
  pix: 'PIX',
};

export const PAYMENTS_TYPES = {
  manual_physical_card: 'manual_physical_card',
  pix: 'pix',
  physical_card: 'physical_card',
  payment_link: 'payment_link',
  store_credit: 'store_credit',
};

const CARDS_BRANDS = [
  {
    card_type: 'debit',
    card_brand: 'visa',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '53',
  },
  {
    card_type: 'prepaid',
    card_brand: 'visa',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '53',
  },
  {
    card_type: 'debit',
    card_brand: 'visa',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '53',
  },
  {
    card_type: 'prepaid',
    card_brand: 'visa',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '53',
  },
  {
    card_type: 'credit',
    card_brand: 'visa',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '54',
  },
  {
    card_type: 'credit',
    card_brand: 'visa',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '54',
  },
  {
    card_type: 'credit',
    card_brand: 'redeshop',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '55',
  },
  {
    card_type: 'credit',
    card_brand: 'redeshop',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'debit',
    card_brand: 'redeshop',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '55',
  },
  {
    card_type: 'debit',
    card_brand: 'redeshop',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'credit',
    card_brand: 'mastercard',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '56',
  },
  {
    card_type: 'credit',
    card_brand: 'mastercard',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '56',
  },
  {
    card_type: 'debit',
    card_brand: 'mastercard',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '55',
  },
  {
    card_type: 'debit',
    card_brand: 'mastercard',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'prepaid',
    card_brand: 'mastercard',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '55',
  },
  {
    card_type: 'prepaid',
    card_brand: 'mastercard',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'credit',
    card_brand: 'hipercard',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '57',
  },
  {
    card_type: 'credit',
    card_brand: 'hipercard',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '57',
  },
  {
    card_type: 'debit',
    card_brand: 'hipercard',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '57',
  },
  {
    card_type: 'debit',
    card_brand: 'hipercard',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '57',
  },
  {
    card_type: 'debit',
    card_brand: 'elo',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '58',
  },
  {
    card_type: 'debit',
    card_brand: 'elo',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '58',
  },
  {
    card_type: 'prepaid',
    card_brand: 'elo',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '58',
  },
  {
    card_type: 'prepaid',
    card_brand: 'elo',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '58',
  },
  {
    card_type: 'credit',
    card_brand: 'elo',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '59',
  },
  {
    card_type: 'credit',
    card_brand: 'elo',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '59',
  },
  {
    card_type: 'credit',
    card_brand: 'american-express',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'americanexpress',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'american express',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'amex',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'american-express',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'americanexpress',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'american express',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'amex',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'debit',
    card_brand: 'cabal',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '70',
  },
  {
    card_type: 'debit',
    card_brand: 'cabal',
    linx_payment_type: 'E',
    payment_type_code: 'physical_card',
    linx_administrative_code: '70',
  },
  {
    card_type: 'credit',
    card_brand: 'cabal',
    linx_payment_type: '7',
    payment_type_code: 'payment_link',
    linx_administrative_code: '71',
  },
  {
    card_type: 'credit',
    card_brand: 'cabal',
    linx_payment_type: 'A',
    payment_type_code: 'physical_card',
    linx_administrative_code: '71',
  },
  {
    card_type: 'gift_card',
    card_brand: null,
    linx_payment_type: '@',
    payment_type_code: 'store_credit',
    linx_administrative_code: null,
  },
  {
    card_type: 'others',
    card_brand: null,
    linx_payment_type: 'Y',
    payment_type_code: 'store_credit',
    linx_administrative_code: null,
  },
  {
    card_type: null,
    card_brand: null,
    linx_payment_type: '5',
    payment_type_code: 'pix',
    linx_administrative_code: null,
  },
  {
    card_type: 'pix',
    card_brand: null,
    linx_payment_type: '5',
    payment_type_code: 'pix',
    linx_administrative_code: null,
  },
  {
    card_type: 'pix',
    card_brand: null,
    linx_payment_type: '5',
    payment_type_code: 'payment_link',
    linx_administrative_code: null,
  },
  {
    card_type: 'store_credit',
    card_brand: null,
    linx_payment_type: 'Y',
    payment_type_code: 'payment_link',
    linx_administrative_code: null,
  },
  {
    card_type: 'gift_card',
    card_brand: null,
    linx_payment_type: '@',
    payment_type_code: 'payment_link',
    linx_administrative_code: null,
  },
  {
    card_type: 'debit',
    card_brand: 'visa',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '53',
  },
  {
    card_type: 'prepaid',
    card_brand: 'visa',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '53',
  },
  {
    card_type: 'credit',
    card_brand: 'visa',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '54',
  },
  {
    card_type: 'credit',
    card_brand: 'redeshop',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'debit',
    card_brand: 'redeshop',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'credit',
    card_brand: 'mastercard',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '56',
  },
  {
    card_type: 'debit',
    card_brand: 'mastercard',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'prepaid',
    card_brand: 'mastercard',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '55',
  },
  {
    card_type: 'credit',
    card_brand: 'hipercard',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '57',
  },
  {
    card_type: 'debit',
    card_brand: 'hipercard',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '57',
  },
  {
    card_type: 'debit',
    card_brand: 'elo',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '58',
  },
  {
    card_type: 'prepaid',
    card_brand: 'elo',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '58',
  },
  {
    card_type: 'credit',
    card_brand: 'elo',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '59',
  },
  {
    card_type: 'credit',
    card_brand: 'american-express',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'americanexpress',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'american express',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'credit',
    card_brand: 'amex',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '60',
  },
  {
    card_type: 'debit',
    card_brand: 'cabal',
    linx_payment_type: 'E',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '70',
  },
  {
    card_type: 'credit',
    card_brand: 'cabal',
    linx_payment_type: 'A',
    payment_type_code: 'manual_physical_card',
    linx_administrative_code: '71',
  },
];

export const tempConstants = Object.freeze({ CARDS_BRANDS });
